<template>
  <modal
    :value="show"
    title="Envoyer les attributions"
    okText="Fermer"
    effect="fade/zoom"
    large
    :backdrop="false"
    @ok="$emit('close')"
  >
    <template v-if="attribution">
      <div v-if="filters">
        <h4>Filtres utilisés:</h4>
        <ul>
          <li>Par appli: {{ filters.appli ? "Oui" : "Non" }}</li>
          <li v-if="filters.gender">Par genre: {{ filters.gender }}</li>
          <li v-if="filters.status && filters.status.length !== 0">
            Par statut: {{ getCoachStatus(filters.status) }}
          </li>
          <li v-if="filters.prestations && filters.prestations.length !== 0">
            Par prestations: {{ getCoachPrestations(filters.prestations) }}
          </li>
          <li v-if="filters.tags && filters.tags.length !== 0">
            Par tags: {{ getCoachTags(filters.tags) }}
          </li>
          <li v-if="filters.lang">Par langue: {{ filters.lang }}</li>
          <li>Par disponibilité: {{ filters.availability ? "Oui" : "Non" }}</li>
          <li>Par rayon d'action: {{ filters.range ? "Oui" : "Non" }}</li>
          <li>Pour un crédit de: {{ formatPrice(filters.credit) }}</li>
        </ul>
      </div>
      <hr />
      <div class="d-flex justify-content-end" style="gap: 8px">
        <button
          v-if="coachs.queue && coachs.queue.length > 0"
          class="btn btn-warning"
          @click="pushNotification()"
        >
          Envoyer une notification
        </button>
        <button
          v-if="coachs.available && coachs.available.length > 0"
          class="btn btn-primary"
          @click="sendAttribution()"
        >
          Envoyer les attributions
        </button>
      </div>
      <div class="row modal-coachs">
        <div class="col-md-3">
          <div v-if="coachs.accepted && coachs.accepted.length > 0">
            <p class="text-success">
              {{ coachs.accepted.length }} coach{{
                coachs.accepted.length > 1 ? "s ont" : " à"
              }}
              accepté{{ coachs.accepted.length > 1 ? "s" : "" }}.
            </p>
            <ul>
              <li v-for="coach of coachs.accepted" :key="coach.id">
                <a @click.prevent="goToCoachDetails(coach.id)" href="#">
                  <i class="icon-user"></i> {{ coach.name }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else>Aucun coach accepté</div>
        </div>
        <div class="col-md-3">
          <div v-if="coachs.rejected && coachs.rejected.length > 0">
            <p class="text-danger">
              {{ coachs.rejected.length }} coach{{
                coachs.rejected.length > 1 ? "s ont" : " à"
              }}
              rejeté{{ coachs.rejected.length > 1 ? "s" : "" }}.
            </p>
            <ul>
              <li v-for="coach of coachs.rejected" :key="coach.id">
                <a @click.prevent="goToCoachDetails(coach.id)" href="#">
                  <i class="icon-user"></i> {{ coach.name }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else>Aucun coach refusé</div>
        </div>
        <div class="col-md-3">
          <div v-if="coachs.queue && coachs.queue.length > 0">
            <p class="text-warning">
              {{ coachs.queue.length }} coach{{
                coachs.queue.length > 1 ? "s" : ""
              }}
              en attente.
            </p>
            <ul>
              <li v-for="coach of coachs.queue" :key="coach.id">
                <a @click.prevent="goToCoachDetails(coach.id)" href="#">
                  <i class="icon-user"></i> {{ coach.name }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else>Aucun coach en attente</div>
        </div>
        <div class="col-md-3">
          <div v-if="coachs.available && coachs.available.length > 0">
            <p>
              {{ coachs.available.length }} coach{{
                coachs.available.length > 1 ? "s disponibles" : " disponible"
              }}.
            </p>
            <ul>
              <li v-for="coach of coachs.available" :key="coach.id">
                <a @click.prevent="goToCoachDetails(coach.id)" href="#">
                  <i class="icon-user"></i> {{ coach.name }}
                </a>
              </li>
            </ul>
          </div>
          <div v-else>Aucun coach disponible</div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click="$emit('close')">
          Fermer
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";

import Modal from "vue-strap/src/Modal";

export default {
  components: {
    Modal,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    attribution: {
      type: Object,
      default: null,
    },

    coachs: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      prestations: [],
      tags: [],
    };
  },

  created() {
    this.fetchSettings();
  },

  computed: {
    ...mapGetters({
      coachStatus: "getCoachStatus",
    }),

    filters() {
      return this.attribution?.filters;
    },
  },

  methods: {
    async fetchSettings() {
      try {
        const { data } = await this.$api.get("/settings");

        if (data["intervenants_prestations"]) {
          this.prestations = data["intervenants_prestations"].map(
            (prestation) => ({
              label: prestation,
              value: prestation,
            }),
          );
        }

        if (data["intervenants_tags"]) {
          this.tags = data["intervenants_tags"].map((tag) => ({
            label: tag,
            value: tag,
          }));
        }
      } catch (e) {
        this.$errorToast("Impossible de récupérer les paramètres");
      }
    },

    getCoachStatus(dataStatus) {
      const status = this.coachStatus.filter((s) =>
        dataStatus.includes(s.value),
      );

      if (status.length === 0) {
        return "";
      }

      return status.map((s) => s.label).join(", ");
    },

    getCoachPrestations(dataPrestations) {
      const prestations = this.prestations.filter((p) =>
        dataPrestations.includes(p.value),
      );

      if (prestations.length === 0) {
        return "";
      }

      return prestations.map((p) => p.label).join(", ");
    },

    getCoachTags(dataTags) {
      const tags = this.tags.filter((p) => dataTags.includes(p.value));

      if (tags.length === 0) {
        return "";
      }

      return tags.map((p) => p.label).join(", ");
    },

    goToCoachDetails(coachId) {
      const route = this.$router.resolve({
        name: "user-details",
        params: { id: coachId },
      });

      window.open(route.href, "_blank");
    },

    async sendAttribution() {
      const availables = this.coachs.available || [];

      this.$confirm({
        message: `Êtes vous sûr de vouloir envoyer ${
          availables.length > 1
            ? "ces " + availables.length + " attributions"
            : "cette attribution"
        }.`,
        onConfirm: async () => {
          try {
            this.$emit("loading", true);

            let coachs = [];

            availables.forEach((c) => {
              coachs.push(c.email);
            });

            await this.$api.post(
              `/attributions/coachs/${this.attribution.id}`,
              {
                emails: coachs,
              },
            );

            this.$emit("close");
            this.$successToast("Attribution envoyée avec succès");
          } catch (e) {
            this.$errorToast("Impossible d'envoyer les attributions");
          } finally {
            this.$emit("loading", false);
          }
        },
      });
    },

    async pushNotification() {
      const queue = this.coachs.queue || [];

      this.$confirm({
        message: `Êtes vous sûr de vouloir envoyer ${
          queue.length > 1
            ? "ces " + queue.length + " notifications"
            : "cette notification"
        }.`,
        onConfirm: async () => {
          try {
            this.$emit("loading", true);

            await this.$api.put(
              `/attributions/notification/${this.attribution.id}`,
            );

            this.$emit("close");
            this.$successToast("Notifications envoyées avec succès");
          } catch (e) {
            this.$errorToast("Impossible d'envoyer les notifications");
          } finally {
            this.$emit("loading", false);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.modal-coachs {
  overflow-y: auto;
  max-height: 400px;
  margin-top: 12px;
}
</style>
